import { clerkMiddleware } from "@clerk/tanstack-react-start/server";
import { createStart } from "@tanstack/react-start";

const PRIMARY_APP_ORIGIN = "https://app.afinio.co";

// Subdomains (<community>.afinio.co) are not Clerk satellites — they share the
// root domain, so the production session cookie is shared automatically. We only
// point sign-in/sign-up at the primary domain to keep auth centralized.
export const startInstance = createStart(() => {
  return {
    requestMiddleware: [
      clerkMiddleware({
        signInUrl: `${PRIMARY_APP_ORIGIN}/sign-in`,
        signUpUrl: `${PRIMARY_APP_ORIGIN}/create`,
      }),
    ],
  };
});
